import { HCP_CUBE_NAME, HCP_TERRITORY_CUBE_NAME } from '@/api/hcp';
import { TooltipIcon } from '@/components/base/Icons/TooltipIcon';
import FilterInfoPopup from '@/components/filter/FilterInfoPopup/FilterInfoPopup';
import shouldDisableTerritoryFilter from '@/models/filter/configs/general/utils/shouldDisableTerritoryFilter';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { TERRITORY_FILTER_LIMIT } from '../../filterDefaultLimits';
import shouldHideTerritoryFilter from './utils/shouldHideTerritoryFIlter';

const TERRITORY_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.territory`, `${HCP_CUBE_NAME}.country_name`],
  limit: TERRITORY_FILTER_LIMIT,
});

const territoryFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.territoryLabel',
  type: 'multiselect',
  defaultValue: [],
  disabled: shouldDisableTerritoryFilter,
  placeholder: 'global.filters.formControls.territoryPlaceholder',
  searchable: true,
  clearable: true,
  hidden: shouldHideTerritoryFilter,
  sourceCube: HCP_TERRITORY_CUBE_NAME,
  getOptionsQuery: TERRITORY_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${HCP_TERRITORY_CUBE_NAME}.territory`]);
    if (value === null) return null;
    return {
      value,
      label: value,
      category: toStringOrNull(result[`${HCP_CUBE_NAME}.country_name`]) ?? undefined,
    };
  },
  getTooltip: ({ userInfo }, arrowPosition) => {
    const { countries } = userInfo;
    const countriesToShow = ['DE', 'AT'];
    if (!countries.some(country => countriesToShow.includes(country))) {
      return null;
    }
    return (
      <FilterInfoPopup
        trigger={<TooltipIcon fill="#544f4f" />}
        title="global.filters.formControls.territoryTooltipTitle"
        content="global.filters.formControls.territoryTooltipContent"
        arrowPosition={arrowPosition}
      />
    );
  },
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${HCP_TERRITORY_CUBE_NAME}.territory`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default territoryFilter;
